import React from "react";
import contactBorder from "@assets/images/borders/contactBorder.webp";

const SkeletonAddress: React.FC = () => {
  return (
    <div className="grid grid-cols-2 max-lg:grid-cols-1 gap-7 max-h-[600px] overflow-auto">
      {[1, 2, 3, 4].map((val) => (
        <div key={val}>
          <div className="relative py-5 px-8 max-md:p-4 max-md:border max-md:border-[#89D9EE] max-md:rounded-xl">
            <img
              className="absolute top-0 left-0 size-full max-md:hidden"
              src={contactBorder}
              alt=""
            />
            <div className="relative">
              <div className="me-16">
                <div className="h-10 w-full skeleton"></div>
              </div>
              <div className="flex flex-col gap-1 mt-3">
                <div className="h-9 w-full skeleton"></div>
                <div className="h-9 w-full skeleton"></div>
                <div className="me-24">
                  <div className="h-9 w-full skeleton"></div>
                </div>
              </div>
            </div>
            <div>
              <div className="flex items-center text-base duration-150 absolute bottom-[10%] right-[10%]">
                <div className="h-9 w-16 skeleton"></div>
              </div>
              <div className="flex items-center text-base duration-150 absolute top-[10%] right-[10%]">
                <div className="h-10 w-9 skeleton"></div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SkeletonAddress;
